module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-up-652e34d1.svg";